import { omit, omitBy, isUndefined } from 'lodash';
import { STYLE_POSITION_ATTRIBUTES } from '../getRootPosition/constants';
import getRootPosition from '../getRootPosition';
import getRootTransform from '../getRootTransform';

/**
 * Merges style attributes into svg attributes.
 * @param {Object} style The layer style
 * @param {Boolean} keepOriginalStyle Whether to keep root's original style or not
 * @returns {Object}
 */
const mergeStyleToAttributes = ({ style = {} }, keepOriginalStyle = false) => {
    const positionAttributes = getRootPosition({ style });
    const rootTransform = getRootTransform(style, positionAttributes);

    const { top, left, height, width } = positionAttributes;

    return omitBy(
        {
            height,
            width,
            x: left,
            y: top,
            ...(rootTransform && { transform: rootTransform }),
            style: keepOriginalStyle ? style : omit(style, [...STYLE_POSITION_ATTRIBUTES, 'transform']),
        },
        isUndefined
    );
};

export default mergeStyleToAttributes;
